import React from 'react';
import { IconMinus, IconPlus } from '@tabler/icons-react';
import { NumberDisplay, StepButton, StepperRoot } from './styles';

type TariffQuantityStepperProps = {
  quantity: number;
  min: number;
  max: number;
  onChange: (next: number) => void;
  disabled?: boolean;
  decrementAriaLabel: string;
  incrementAriaLabel: string;
};

const ICON_SIZE = 16;

const TariffQuantityStepper = ({
  quantity,
  min,
  max,
  onChange,
  disabled,
  decrementAriaLabel,
  incrementAriaLabel,
}: TariffQuantityStepperProps) => {
  const canDecrement = !disabled && quantity > min;
  const canIncrement = !disabled && quantity < max;

  const handleDecrement = () => {
    if (canDecrement) onChange(quantity - 1);
  };

  const handleIncrement = () => {
    if (canIncrement) onChange(quantity + 1);
  };

  return (
    <StepperRoot>
      <StepButton
        type='button'
        aria-label={decrementAriaLabel}
        disabled={!canDecrement}
        disabledLook={!canDecrement}
        onClick={handleDecrement}
      >
        <IconMinus size={ICON_SIZE} />
      </StepButton>
      <NumberDisplay aria-live='polite'>{quantity}</NumberDisplay>
      <StepButton
        type='button'
        aria-label={incrementAriaLabel}
        disabled={!canIncrement}
        disabledLook={!canIncrement}
        onClick={handleIncrement}
      >
        <IconPlus size={ICON_SIZE} />
      </StepButton>
    </StepperRoot>
  );
};

export default TariffQuantityStepper;
